import repository from '@/repositories/Repository'

const resource = '/api/customer-zip-group'

/**
 * 顧客郵便番号リポジトリ
 */
export default {
  /**
   *
   * @param {*} customerGroupId
   */
  get(customerGroupId) {
    return repository.giggle
      .get(`${resource}/${customerGroupId}`)
      .then(r => r.data)
  },
}
